// @flow
import _ from 'lodash'
import React, { useEffect, useRef, useState } from 'react'
import {
  View,
  FlatList,
  TouchableOpacity,
  Text,
  Animated,
} from 'react-native'
import { useTranslation } from 'react-i18next'
import { RectButton } from 'react-native-gesture-handler'
import Swipeable from 'react-native-gesture-handler/Swipeable'
import { useSafeArea } from 'react-native-safe-area-context'
import { IonAlert } from '@ionic/react'

import Button from '../../../../components/Button'
import Row from '../../../../components/Row'
import { useLocalPreference } from '../../../global'
import { useAstrolabe } from '../../context'
import styles from './style'

type RightActionButtonProps = {
  text?: string,
  color?: string,
  x?: number,
  progress: Object,
  onPress: Function,
}
const RightActionButton = ({
  text,
  color,
  x,
  progress,
  onPress,
}: RightActionButtonProps) => {
  // const trans = progress.interpolate({
  //   inputRange: [0, 1],
  //   outputRange: [x, 0],
  // })
  return (
    <Animated.View style={{ flex: 1 }}>
      <RectButton
        style={[
          { alignItems: 'center', flex: 1, justifyContent: 'center' },
          { backgroundColor: color },
        ]}
        onPress={onPress}>
        <Text
          style={{
            color: 'white',
            fontSize: 16,
            backgroundColor: 'transparent',
            padding: 10,
          }}>
          {text}
        </Text>
      </RectButton>
    </Animated.View>
  )
}

const TARow = ({
  theme,
  data,
  onPress,
  editText,
  onEdit,
  deleteText,
  onDelete,
}) => {
  const swipeRef = useRef(null)
  const { palette } = theme
  return (
    <Row style={{ width: '100%', marginVertical: 0 }}>
      <TouchableOpacity
        style={{ paddingVertical: 12, paddingHorizontal: 16, flexGrow: 1 }}
        onPress={() => {
          onPress()
        }}>
        <Text style={{ color: palette.text.default }}>{data.name}</Text>
      </TouchableOpacity>
      <Row style={{ width: 192 }}>
        <RightActionButton
          text={editText}
          color="#ffab00"
          x={128}
          // progress={progress}
          onPress={() => {
            onEdit()
          }}
        />
        <RightActionButton
          text={deleteText}
          color="#dd2c00"
          x={64}
          // progress={progress}
          onPress={() => {
            onDelete()
          }}
        />
      </Row>
    </Row>
  )
}

type Props = {
  navigation: Object,
}
const TAList = ({ navigation }: Props) => {
  const insets = useSafeArea()
  const { t } = useTranslation()
  const { theme } = useLocalPreference()
  const {
    taList,
    getCachedTAList,
    setTAList,
    setDraftTA,
    setSelectedTA,
  } = useAstrolabe()
  const { palette } = theme

  const [deleteAlert, setDeleteAlert] = useState({ visible: false })
  useEffect(() => {
    getCachedTAList()
  }, [])

  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: palette.background.default,
          paddingBottom: insets.bottom,
        },
      ]}>
      <FlatList
        data={taList}
        style={[styles.container]}
        contentContainerStyle={{ flexGrow: 1 }}
        renderItem={({ item, index }) => (
          <TARow
            theme={theme}
            data={item}
            onPress={() => {
              setSelectedTA(item)
              navigation.navigate('astrolabe')
            }}
            editText={t('edit')}
            deleteText={t('delete')}
            onEdit={() => {
              setDraftTA(item)
              navigation.navigate('modal')
            }}
            onDelete={() => {
              console.log('onDelete')
              setDeleteAlert({ visible: true, targetIndex: index })
            }}
          />
        )}
        ListEmptyComponent={
          <View
            style={[
              { flex: 1, alignItems: 'center', justifyContent: 'center', padding: 16 },
            ]}>
            <Text style={{ color: palette.text.default, marginBottom: 12 }}>{t('astrolabe.no_data')}</Text>
            <Button
              theme={theme}
              label={t('astrolabe.add_one')}
              onPress={() => navigation.navigate('modal')}
            />
          </View>
        }
      />
      <IonAlert
        isOpen={deleteAlert.visible}
        onDidDismiss={() => setDeleteAlert({ visible: false })}
        header={t('astrolabe.delete_record')}
        message={t('astrolabe.r_u_sure_to_delete')}
        buttons={[
          {
            text: t('cancel'),
            role: 'cancel',
            handler: () => {}
          },
          {
            text: t('sure'),
            handler: () => {
              const arr = _.concat([], taList)
              _.remove(arr, (ta, idx) => idx === deleteAlert.targetIndex)
              setTAList(arr)
            }
          }
        ]}
      />
    </View>
  )
}
export default TAList
